import React from 'react';
import { Bell } from 'react-bootstrap-icons';
import Logo from '../../images/SKIP.svg';
import { logoutUser } from '../../api/api';
import HeaderCalendarButton from './HeaderCalendarButton';

interface MobileHeaderProps {
  onToggleSidebar: () => void;
  onOpenNotifications: () => void;
  onOpenSettings: () => void;
  unreadCount: number;
  userData: any;
  showNavChrome?: boolean;
  showOnboardingLogout?: boolean;
  fullWidthHeader?: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({
  onToggleSidebar,
  onOpenNotifications,
  onOpenSettings,
  unreadCount,
  userData,
  showNavChrome = false,
  showOnboardingLogout = false,
  fullWidthHeader = false,
}) => {
  return (
    <header className={`mobile-header${fullWidthHeader ? ' mobile-header--full-width' : ''}`}>
      {/* Left: Menu */}
      {showNavChrome ? (
        <button className="mh-icon-btn" onClick={onToggleSidebar} aria-label="Open menu">
          <span className="hamburger" />
        </button>
      ) : (
        <div className="mh-icon-btn mh-icon-btn--placeholder" aria-hidden />
      )}

      {/* Center: Logo */}
      <div className="mh-logo-wrapper">
        <img src={Logo} alt="SkipScreen" className="mh-logo" />
      </div>

      {/* Right: Actions (hidden until onboarding is complete) */}
      {showNavChrome ? (
        <>
          <HeaderCalendarButton />
          <div className="mh-actions">
            <button
              className="mh-icon-btn notif-btn"
              onClick={onOpenNotifications}
              aria-label="Notifications"
            >
              <Bell size={20} />
              {unreadCount > 0 && (
                <span className="notif-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
              )}
            </button>

            <button className="mh-avatar-btn" onClick={onOpenSettings} aria-label="Open settings">
              {userData?.profileImg ? (
                <img src={userData.profileImg} alt="User avatar" className="mh-avatar" />
              ) : (
                <div className="mh-avatar-placeholder" />
              )}
            </button>
          </div>
        </>
      ) : showOnboardingLogout ? (
        <button
          type="button"
          className="header-onboarding-logout header-onboarding-logout--mobile"
          onClick={() => logoutUser()}
        >
          Log out
        </button>
      ) : null}
    </header>
  );
};

export default MobileHeader;
